export const searchSuggestionsTitleMapping: Record<string, string> = {
  term: "Search Terms",
  case: "Case",
  index: "Index",
};
